angular.module("app").controller("PopupsListPageController", [
    '$scope',
    'pageStatuses',
    'preloadedPopupsList',
    '$timeout',
    'popupsService',
    'errorHandler',
    '$state',
    'logger',
    'pagination',
    '$cookies',
    'settingsService',
    function ($scope, pageStatuses, preloadedPopupsList, $timeout, popupsService, errorHandler, $state, logger, pagination, $cookies, settingsService) {

        var pendingListRequest,
            settings = settingsService.getSettings();

        $scope.filterOptions = {
            status: pageStatuses[0],
            language: $cookies.get("preferedLanguage") || settings.skin.defaultLang
        };
        $scope.languages = settings.skin.languages;
        $scope.pageStatuses = pageStatuses;
        $scope.popups = angular.copy(preloadedPopupsList.popups|| []);

        $scope.pagination = pagination.init(function () {
                !!pendingListRequest && $timeout.cancel(pendingListRequest);
                pendingListRequest = $timeout(function () {
                    $scope.updateList({
                        current_page: $scope.pagination.page,
                        lang: $cookies.get("preferedLanguage"),
                        limit: $scope.pagination.limit
                    })
                }, 300);
            }, preloadedPopupsList.total_count);

        $scope.updateList = function (externalOptions) {
            var requestObject = {
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status
            };
            if (!!externalOptions) {
                angular.extend(requestObject, externalOptions);
                $cookies.put("preferedLanguage", externalOptions.lang || settings.skin.defaultLang)
            }
            popupsService.getPopups(requestObject).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.popups = angular.copy(response.popups);
                        $scope.pagination.totalItems = response.total_count;
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.editPopup = function (popup) {
            $state.go('main.popups.edit', {popupId: popup.id});
        };

        $scope.deletePopup = function (popup) {
            var requestData = {
                id: popup.id
            };

            popupsService.deletePopupById(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.updateList({
                            current_page: $scope.pagination.page,
                            lang: $cookies.get("preferedLanguage"),
                            limit: $scope.pagination.limit
                        });
                        logger.logSuccess("User has been successfully archived");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.getDateTime = function (dateString) {
            return (dateString) ? new Date(dateString).getTime() : ""
        };

        $scope.publishPopup = function (popup) {
            var requestData = {
                popup: {
                    id: popup.id,
                    status: "published"
                }
            };

            popupsService.update(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.updateList({
                            current_page: $scope.pagination.page,
                            lang: $cookies.get("preferedLanguage"),
                            limit: $scope.pagination.limit
                        });
                        logger.logSuccess("Popup has been successfully published");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };
    }
]);